const parseBool = (value: string): boolean => (value === 'true' ? true : false);

export { parseBool };
